<script>
    import AlertTypeDescriptions from "../../Alerts/AlertTypeDescriptions";
    import AuthStore from "../../Auth/Store";
    import IdentityHelper from "../../Branding/IdentityHelper";
    import User from "../../Branding/User";
    import VesselColour from "../../Enums/VesselColour";
    import IconMode from "../../Map/Enums/IconMode";
    import VesselTypeCategoryMeta from "../../Models/Enums/VesselTypeCategoryMeta";
    import AlertKey from "./AlertKey.svelte";

    let alertConfigs = IdentityHelper.current().alertConfigs;
    let user = AuthStore.session.user;
    $: {
        $user;
        alertConfigs = IdentityHelper.current().alertConfigs;
    }

    export let iconMode;
    export let iconType = "vessel";
    export let defaultModeName = "Alert Type";
</script>

{#if iconMode === IconMode.TIME_DIFFERENCE || iconMode == IconMode.TIME_SINCE_PREVIOUS_UPDATE}
    <AlertKey long="0-8 hours since update" short="0-8h" iconImage={VesselColour.LIGHTGREEN} iconType={iconType} />
    <AlertKey long="8-16 hours since update" short="8-16h" iconImage={VesselColour.ORANGE} iconType={iconType} />
    <AlertKey long="16-24 hours since update" short="16-24h" iconImage={VesselColour.LIGHTRED} iconType={iconType} />
    <AlertKey long=">24 hours since update" short="24h+" iconImage={VesselColour.DARKBLUE} iconType={iconType} />
    <AlertKey long=">7 days since update" short="7d+" iconImage={VesselColour.BLACK} iconType={iconType} />
{:else if iconMode === IconMode.ALERT}
    {#if defaultModeName == "Alert Type"}
        {#each alertConfigs as alertConfig}
            {#if User.hasAlertType(alertConfig.alertType)}
                <AlertKey
                    long={AlertTypeDescriptions[alertConfig.alertType]}
                    short={alertConfig.alertType}
                    iconImage={alertConfig.vesselColour} 
                    iconType={iconType} />

            {/if}
        {/each}
    {:else}
        <AlertKey
            long={"All Vessels"}
            short={"All"}
            iconImage={VesselColour.WHITE} 
            iconType={iconType} />
    {/if}
{:else if iconMode === IconMode.SPEED}
    <AlertKey long="<0.1 knots" short="<0.1kn" iconImage={VesselColour.LIGHTGREEN} iconType={iconType}  />
    <AlertKey long="0.1-10 knots" short="0.1-10kn" iconImage={VesselColour.ORANGE} iconType={iconType} />
    <AlertKey long="10-18 knots" short="10-18kn" iconImage={VesselColour.LIGHTRED} iconType={iconType} />
    <AlertKey long=">18 knots" short=">18kn" iconImage={VesselColour.PURPLE} iconType={iconType} />
    <AlertKey long="Unknown" short="Unknown" iconImage={VesselColour.BLACK} iconType={iconType} />
{:else if iconMode === IconMode.VESSEL_TYPE}

    {#each Object.keys(VesselTypeCategoryMeta) as key, index}
        <AlertKey long={VesselTypeCategoryMeta[key].name} short={VesselTypeCategoryMeta[key].shortname} iconImage={VesselTypeCategoryMeta[key].color} iconType={iconType} />
    {/each}
    <AlertKey long="Other/Unknown" short="Other" iconImage={VesselColour.BLACK} iconType={iconType} />

    <!-- {:else if $mode === IconMode.INDEX} -->
{:else if iconMode === IconMode.RISK_LEVEL}
    <AlertKey long="Critical" short="Critical" iconImage={VesselColour.LIGHTRED} iconType={iconType} />
    <AlertKey long="High" short="High" iconImage={VesselColour.ORANGE} iconType={iconType} />
    <AlertKey long="Medium" short="Medium" iconImage={VesselColour.YELLOW} iconType={iconType} />
    <AlertKey long="Low" short="Low" iconImage={VesselColour.LIGHTGREEN} iconType={iconType} />
    <AlertKey long="Very Low" short="Very Low" iconImage={VesselColour.GRAY} iconType={iconType} />
    <AlertKey long="N/A" short="N/A" iconImage={VesselColour.WHITE} iconType={iconType} />

{:else if iconMode === IconMode.AVIATION_ALERT}
    {#if defaultModeName == "Alert Type"}
        <AlertKey
            long={"Entered Airspace"}
            short={"EAS"}
            iconImage={VesselColour.MAGENTA} 
            iconType={iconType} />
    {:else}
        <AlertKey
            long={"All Aircraft"}
            short={"All"}
            iconImage={VesselColour.WHITE} 
            iconType={iconType} />
    {/if}
{:else if iconMode === IconMode.AVIATION_SIL}
    <AlertKey long="0" short="0" iconImage={VesselColour.LIGHTRED} iconType={iconType} />
    <AlertKey long="1" short="1" iconImage={VesselColour.ORANGE} iconType={iconType} />
    <AlertKey long="2" short="2" iconImage={VesselColour.YELLOW} iconType={iconType} />
    <AlertKey long="3" short="3" iconImage={VesselColour.LIGHTGREEN} iconType={iconType}  />
    <AlertKey long="N/A" short="N/A" iconImage={VesselColour.WHITE} iconType={iconType} />
{:else if iconMode === IconMode.AVIATION_NACP}
    <AlertKey long="0" short="0" iconImage={VesselColour.LIGHTRED} iconType={iconType} />
    <AlertKey long="1 - 6" short="1-6" iconImage={VesselColour.ORANGE} iconType={iconType}  />
    <AlertKey long="7 - 8" short="7-8" iconImage={VesselColour.YELLOW} iconType={iconType} />
    <AlertKey long="9+" short="9+" iconImage={VesselColour.LIGHTGREEN} iconType={iconType} />
    <AlertKey long="N/A" short="N/A" iconImage={VesselColour.WHITE} iconType={iconType} />
{/if}